<template>
  <div
    class="productsCont"
    style="position: relative; width: 69.5%; margin-left: 20px"
  >
    <div
      style="
        position: relative;
        height: 665px;
        border-bottom: 1px solid #d7dde4;
      "
    >
      <div class="productsTit padding-10" v-show="!isDisabled">
        <div id="producstPic">图片信息</div>
      </div>
      <div class="head-tabs">
        <RadioGroup v-model="imageTagVal" type="button">
          <Radio
            v-for="(tag, index) in imageLanguageData"
            :key="`${tag.value}-${index}`"
            :label="tag.value"
            >{{ tag.label }}</Radio
          >
        </RadioGroup>
      </div>
      <div class="products-content" style="overflow: auto; height: 508px">
        <div
          v-for="lang in imageLanguageData"
          :key="lang.value"
          v-show="imageTagVal === lang.value"
        >
          <!-- 占位图 -->
          <div
            class="picBox padding-10"
            v-if="getImagesByLang(lang.value).length === 0"
          >
            <Icon type="image" size="50" color="#d4d4d4"></Icon>
            <p>未添加图片</p>
          </div>
          <div class="padding-10 product-img-box">
            <!-- 显示图片 -->
            <CheckboxGroup v-model="currentDelImgsValue">
              <template>
                <transition-group name="flip-list">
                  <div
                    v-for="(img, index) in getImagesByLang(lang.value)"
                    :key="`${index}-${img.productImageId || img.path}`"
                    style="display: inline"
                    v-show="isShowPicList ? true : index < 5"
                    :style="
                      isShowPicList
                        ? 'width:100px;height:100px'
                        : 'width:200px;height:200px'
                    "
                    draggable="true"
                    :class="{ active: oldVal == img && isActive == img }"
                    @dragstart="dragStart(img, index)"
                    @dragenter="dragEnter(img, index)"
                    @dragend="dragend(img, index)"
                  >
                    <div
                      class="product-upload-list"
                      :style="isShowPicList ? 'width:100px;height:100px' : ''"
                    >
                      <Checkbox :label="index">
                        <img
                          :src="filenodeViewTargetUrl + img.path"
                          :key="`${index}-${img.productImageId || img.path}`"
                        />
                        <div
                          class="product-upload-list-cover"
                          style="padding-top: 30%"
                        >
                          <Icon
                            title="放大预览"
                            type="ios-eye-outline"
                            @click.native.prevent.stop="showViewer(index)"
                          />
                          <Icon
                            title="设为主图"
                            type="ios-home-outline"
                            @click.native.prevent.stop="
                              setProductPrimaryImg(index)
                            "
                            v-if="!isDisabled"
                          ></Icon>
                          <Icon
                            title="删除"
                            type="ios-trash-outline"
                            @click.native.prevent.stop="removeProductImg(index)"
                            v-if="!isDisabled"
                          ></Icon>
                        </div>
                      </Checkbox>
                    </div>
                  </div>
                </transition-group>
              </template>
              <template v-for="(file, index) in uploadFiles">
                <div
                  :key="index"
                  v-if="file.status !== 'finished'"
                  class="product-upload-list"
                >
                  <Progress
                    v-if="file.showProgress"
                    :percent="file.percentage"
                  ></Progress>
                </div>
              </template>
            </CheckboxGroup>
          </div>
        </div>
        <Spin size="large" fix v-if="uploadFilesLoading"></Spin>
      </div>

      <div style="position: absolute; right: 10px; top: 45%">
        <Button class="pictureBtn" @click="loadingPicture">{{
          isShowPicList ? "隐藏列表" : "展开列表"
        }}</Button>
      </div>

      <div style="margin-top: 30px">
        <div
          class="urlBtn"
          style="position: absolute; right: 30px; bottom: 20px"
        >
          <Button
            icon="ios-color-wand-outline"
            type="primary"
            ghost
            style="margin-right: 10px"
            @click="openAiGenerateModal"
            v-if="!isDisabled"
            >AI生图</Button
          >
          <Button style="margin-right: 10px" @click="selectAllPic">{{
            isAllSelectPic ? "取消全选" : "全选"
          }}</Button>
          <Button
            style="margin-right: 10px"
            @click="downloadSelectPic"
            :loading="downPicLoading"
            >下载选中图片</Button
          >
          <Button @click="delImgs" style="margin-right: 10px" v-if="!isDisabled"
            >删除选中图片</Button
          >
          <dytUpload
            v-if="!isDisabled"
            ref="uploadProductInfoImg"
            file-name="files"
            :headers="uploadFilesHeader"
            :max-size="uploadFilesMaxSize"
            :on-exceeded-size="uploadExceedSize"
            :show-upload-list="false"
            :format="['jpg', 'png', 'gif']"
            accept="image/*"
            :on-success="uploadFilesSuccess"
            :on-error="uploadFilesError"
            :on-format-error="handleFormatError"
            multiple
            :before-upload="beforeUpload"
            :action="uploadFilesUrl"
          >
            <Button icon="image" class="mr10">上传本地图片</Button>
          </dytUpload>
          <Button icon="link" @click="addNetWorkImg" v-if="!isDisabled"
            >上传图片URL</Button
          >
        </div>
      </div>
    </div>
    <div class="mt20 mr10">
      <Form-item
        label="附件说明书及产品资质(限PDF文件)："
        prop="instructionsPath"
        :label-width="220"
      >
        <uploadSampleFile
          class="accessory-style"
          :value="instructionsPath"
          @valueChange="(val) => $emit('update:instructionsPath', val)"
          :disabled="isDisabled"
          accept-error-txt="文件格式不对，请上传格式为 pdf 的文件"
          tipTxt="请选择文件"
          :file-max-size="60"
          :isPreview="true"
          :showSuffix="true"
          :actionUrl="accessoryApi"
          :upload-props="{
            multiple: true,
            accept: ['application/pdf'],
          }"
        />
      </Form-item>
    </div>
    <div class="mr10">
      <Form-item label="图片类型：" prop="pictureTypeList" :label-width="150">
        <CheckboxGroup
          :value="pictureTypeList"
          @on-change="(val) => $emit('update:pictureTypeList', val)"
        >
          <Checkbox
            v-for="(box, index) in pictureTypeData"
            :key="`${box.value}-${index}`"
            :label="box.value"
          >
            {{ box.label }}
          </Checkbox>
        </CheckboxGroup>
      </Form-item>
    </div>

    <!-- 上传图片url -->
    <Modal
      :transfer="false"
      v-model="addNetWorkUrlModal"
      title="从地址添加图片"
      :loading="waitingUrlOk"
      @on-ok="addNetWorkImgOk"
    >
      <Form :label-width="100" label-position="left">
        <Form-item label="图片地址：">
          <Input ref="addNetWorkUrlInput" placeholder="http://"></Input>
        </Form-item>
      </Form>
    </Modal>

    <!-- AI生图弹窗（SPU维度）-->
    <aiGenerateModal
      v-model="aiGenerateModalVisible"
      dimension="spu"
      :product-id="productId"
      :multi-lang-image-data="imagesInfoData"
      :filenode-view-target-url="filenodeViewTargetUrl"
      @on-generate="handleAiGenerate"
    />
  </div>
</template>

<script>
import api from "@/api/api";
import uploadSampleFile from "./uploadSampleFile";
import aiGenerateModal from "./aiGenerateModal";
import { api as viewerApi } from "v-viewer";

/**
 * @description 商品图片信息组件
 * @author 前端开发
 * @date 2026-06-13
 * @功能说明
 *   1. 图片展示：支持拖拽排序、放大预览、设为主图、删除
 *   2. 图片上传：支持本地图片批量上传、网络图片URL上传
 *   3. 图片下载：支持选中图片批量下载
 *   4. 附件上传：支持pdf附件说明书上传
 *   5. 图片类型：支持多选图片类型标签
 */
export default {
  name: "productImageInfo",
  components: {
    uploadSampleFile,
    aiGenerateModal,
  },
  props: {
    /** 商品图片列表 */
    imagesInfoData: {
      type: Array,
      default: () => [],
    },
    /** 是否禁用编辑 */
    isDisabled: {
      type: Boolean,
      default: false,
    },
    /** 附件说明书路径 */
    instructionsPath: {
      type: [String, Array, Object],
      default: "",
    },
    /** 图片类型选中值 */
    pictureTypeList: {
      type: Array,
      default: () => [],
    },
    /** 商品SPU编码 */
    spu: {
      type: String,
      default: "",
    },
    /** 图片类型选项数据 */
    pictureTypeData: {
      type: Array,
      default: () => [],
    },
    /** 文件服务器查看地址前缀 */
    filenodeViewTargetUrl: {
      type: String,
      default: "",
    },
    /** 商品信息 */
    productInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 图片标签值
      imageTagVal: "common",
      /** 按语言分组存储选中的图片索引（key: language, value: [index, ...]） */
      delImgsValue: {},
      /** 是否展开图片列表（true展开全部，false只显示前5张） */
      isShowPicList: false,
      /** 当前显示的图片数量 */
      picNum: 5,
      /** 上传中的文件列表 */
      uploadFiles: [],
      /** 上传loading状态 */
      uploadFilesLoading: false,
      /** 下载选中图片的loading状态 */
      downPicLoading: false,
      /** 图片上传接口地址 */
      uploadFilesUrl: api.upload_files + "?basePath=/product",
      /** 上传文件大小限制（kb） */
      uploadFilesMaxSize: 10240,
      /** 单次最多上传图片数量 */
      uploadMaxLength: 20,
      /** 待上传的文件FormData列表 */
      uploadFilesList: [],
      /** 上传延迟定时器 */
      uploadFilesTime: null,
      /** 上传完成后的回调函数 */
      uploadFilesCalLback: () => {},
      /** 是否正在上传中（触发uploadFilesListHand） */
      isUploading: false,
      /** 拖拽开始时的图片值 */
      oldVal: 0,
      /** 拖拽开始时的图片索引 */
      oldValIndex: null,
      /** 拖拽进入时的图片值 */
      newOld: 0,
      /** 拖拽进入时的图片索引 */
      newOldIndex: null,
      /** 当前激活（拖拽中）的图片 */
      isActive: -1,
      /** 是否正在点击（防止拖拽触发点击） */
      isClick: false,
      /** 网络图片上传模态框显示状态 */
      addNetWorkUrlModal: false,
      /** 网络图片上传确认按钮loading状态 */
      waitingUrlOk: true,
      /** 附件上传接口地址 */
      accessoryApi: api.uploadInstructions,
      /** AI生图弹窗显示状态 */
      aiGenerateModalVisible: false,
    };
  },
  computed: {
    /** 上传请求头（包含erp和dyt认证信息） */
    uploadFilesHeader() {
      return {
        ...this.$store.getters.erpRequestHeaders,
        ...this.$store.getters.dytRequestHeaders,
      };
    },
    /** 当前语言分组下的图片列表 */
    currentImages() {
      if (this.$common.isEmpty(this.imagesInfoData)) return [];
      const group = this.imagesInfoData.find(
        (item) => item.language === this.imageTagVal,
      );
      return group ? group.images : [];
    },
    /** 当前tab选中的图片索引数组 */
    currentDelImgsValue: {
      get() {
        return this.delImgsValue[this.imageTagVal] || [];
      },
      set(val) {
        this.$set(this.delImgsValue, this.imageTagVal, val);
      },
    },
    /** 是否已全选当前tab所有图片 */
    isAllSelectPic() {
      const currentSelected = this.delImgsValue[this.imageTagVal] || [];
      if (
        this.$common.isEmpty(this.currentImages) ||
        this.$common.isEmpty(currentSelected)
      )
        return false;
      return this.currentImages.length === currentSelected.length;
    },
    // 图片语言数据
    imageLanguageData() {
      let list = [];
      const textList = {
        common: "通用",
        en: "英语(EN)",
        fr: "法语(FR)",
        de: "德语(DE)",
        ru: "俄语(RU)",
        nl: "荷兰语(NL)",
      };
      this.imagesInfoData.forEach((item) => {
        list.push({
          value: item.language,
          label: item.languageName || textList[item.language] || item.language,
        });
      });
      return list;
    },
    /** 当前图片预览数据（供v-viewer使用） */
    viewerImages() {
      if (this.$common.isEmpty(this.currentImages)) return [];
      return this.currentImages.map((img) => ({
        dataSource: this.filenodeViewTargetUrl + img.path,
      }));
    },
    productId() {
      return this.productInfo.productId || "";
    },
  },
  watch: {
    /** 监听上传状态，触发批量上传 */
    isUploading(val) {
      val && this.uploadFilesListHand();
    },
    // 监听图片语言数据变化，若当前tab不存在则重置为第一个
    imageLanguageData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.$common.isEmpty(val)) return;
        const hasCurrent = val.some((item) => item.value === this.imageTagVal);
        if (!hasCurrent) {
          this.imageTagVal = val[0].value;
        }
      },
    },
  },
  methods: {
    /**
     * 获取指定语言分组的图片列表
     * @param {string} language - 语言代码
     * @returns {Array} 图片数组
     */
    getImagesByLang(language) {
      const group = this.imagesInfoData.find(
        (item) => item.language === language,
      );
      return group ? group.images : [];
    },
    /**
     * 更新当前语言分组的图片列表并同步到父组件
     * @param {Array} newImages - 新的图片对象数组
     */
    updateCurrentImages(newImages) {
      const newProductImages = this.imagesInfoData.map((item) => {
        if (item.language === this.imageTagVal) {
          return {
            ...item,
            images: newImages,
          };
        }
        return { ...item };
      });
      this.$emit("update:imagesInfoData", newProductImages);
    },
    /** 设置指定图片为主图（移到首位） */
    setProductPrimaryImg(index) {
      let newImages = [...this.currentImages];
      let path = newImages.splice(index, 1);
      newImages.unshift(path[0]);
      this.updateCurrentImages(newImages);
    },
    /** 删除指定图片 */
    removeProductImg(index) {
      let newImages = [...this.currentImages];
      newImages.splice(index, 1);
      this.updateCurrentImages(newImages);
    },
    /** dytUpload组件上传成功回调（单文件直接上传场景） */
    uploadFilesSuccess(res, file, uploadFiles) {
      let newImages = [...this.currentImages];
      newImages.push({
        path: file.response.datas[0],
        imageType: null,
        setName: "通用",
        addCommon: true,
      });
      this.updateCurrentImages(newImages);
    },
    /** 文件大小超出限制回调 */
    uploadExceedSize() {
      this.$Message.error("文件大小超出限制，最大为10M");
    },
    /**
     * 上传前钩子（拦截默认上传，改为批量手动上传）
     * @param {File} file - 待上传的文件
     * @returns {boolean} 返回false阻止默认上传行为
     */
    beforeUpload(file) {
      let selectedFiles = this.$refs.uploadProductInfoImg.$refs.input.files;
      let curFileIndex = -1;
      for (let i = 0; i < selectedFiles.length; i++) {
        if (selectedFiles[i] === file) {
          curFileIndex = i;
        }
      }
      if (curFileIndex === 0 && selectedFiles.length > this.uploadMaxLength) {
        this.$Message.error("文件数量超出限制，一次最多可上传20张");
        return false;
      } else if (selectedFiles.length > this.uploadMaxLength) {
        return false;
      }
      let newForm = new FormData();
      newForm.append("files", file);
      this.uploadFilesTime && clearTimeout(this.uploadFilesTime);
      this.uploadFilesList.push(newForm);
      this.uploadFilesTime = setTimeout(() => {
        this.isUploading = true;
        this.uploadFilesCalLback = (arr) => {
          let newImages = [...this.currentImages];
          arr.forEach((newres) => {
            newImages.push({
              path: newres.data.datas[0],
              imageType: null,
              setName: "通用",
              addCommon: true,
            });
          });
          this.updateCurrentImages(newImages);
          this.$nextTick(() => {
            this.uploadFilesCalLback = () => {};
          });
        };
      }, 300);
      return false;
    },
    /** 批量上传文件列表 */
    uploadFilesListHand() {
      this.uploadFilesLoading = true;
      const awaitList = this.uploadFilesList.map((file) => {
        return this.axios.post(
          `${this.uploadFilesUrl}&random=${Math.random()
            .toString()
            .substring(2)}`,
          file,
        );
      });
      Promise.all(awaitList)
        .then((arr) => {
          this.uploadFilesCalLback(arr);
          this.uploadFilesList = [];
          this.isUploading = false;
          this.uploadFilesLoading = false;
        })
        .catch(() => {
          this.uploadFilesList = [];
          this.isUploading = false;
          this.uploadFilesLoading = false;
        });
    },
    /** 上传失败回调 */
    uploadFilesError() {
      this.$Message.error("系统繁忙，请重新尝试");
    },
    /** 文件格式错误回调 */
    handleFormatError() {
      this.$Message.error("文件格式有误");
    },
    /** 全选/取消全选当前tab所有图片 */
    selectAllPic() {
      if (this.isAllSelectPic) {
        this.$set(this.delImgsValue, this.imageTagVal, []);
        return;
      }
      this.$set(
        this.delImgsValue,
        this.imageTagVal,
        this.currentImages.map((pic, index) => index),
      );
    },
    /** 下载选中的图片 */
    downloadSelectPic() {
      if (this.downPicLoading) return;
      const currentSelected = this.delImgsValue[this.imageTagVal] || [];
      if (currentSelected.length === 0) {
        this.$Message.error("未选择图片");
        return;
      }
      const downPicList = this.currentImages
        .filter((i, index) => {
          return currentSelected.includes(index);
        })
        .map((i) => i.path);
      this.downPicLoading = true;
      this.axios
        .post(`${api.imageExport}?spu=${this.spu}`, downPicList, {
          responseType: "blob",
        })
        .then((res) => {
          if (!res || !res.resData) {
            this.downPicLoading = false;
            return this.$Message.error("下载失败");
          }
          this.$common
            .downloadFile(res.resData, { name: res.filename })
            .finally(() => {
              this.downPicLoading = false;
            });
        })
        .catch(() => {
          this.downPicLoading = false;
        });
    },
    /** 删除选中的图片 */
    delImgs() {
      const currentSelected = this.delImgsValue[this.imageTagVal] || [];
      if (currentSelected.length === 0) {
        this.$Message.error("未选择图片");
        return;
      }
      let arr = [];
      this.currentImages.forEach((i, index) => {
        if (currentSelected.indexOf(index) === -1) {
          arr.push(i);
        }
      });
      this.updateCurrentImages(arr);
      this.$set(this.delImgsValue, this.imageTagVal, []);
    },
    /** 打开网络图片上传模态框 */
    addNetWorkImg() {
      this.addNetWorkUrlModal = true;
    },
    /** 网络图片上传确认 */
    addNetWorkImgOk() {
      let reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/;
      if (
        this.$refs.addNetWorkUrlInput.$refs.input.value &&
        !reg.test(this.$refs.addNetWorkUrlInput.$refs.input.value)
      ) {
        this.$Message.error("输入格式有误");
        this.waitingUrlOk = false;
        this.$nextTick(() => {
          this.waitingUrlOk = true;
        });
        return false;
      }
      if (this.$refs.addNetWorkUrlInput.$refs.input.value) {
        this.axios
          .post(api.upload_URlFiles + "?basePath=/product", [
            this.$refs.addNetWorkUrlInput.$refs.input.value,
          ])
          .then((response) => {
            if (response.data.code === 0) {
              let newImages = [...this.currentImages];
              newImages.push({ path: response.data.datas[0], imageType: null });
              this.updateCurrentImages(newImages);
              this.addNetWorkUrlModal = false;
            } else if (response.data.code === 900001) {
              if (response.data.datas.networkErrorFilePaths.length > 0) {
                this.$Message.error("网络异常");
              } else if (response.data.datas.formatErrorFilePaths.length > 0) {
                this.$Message.error("格式不对");
              }
            }
            this.waitingUrlOk = false;
            this.$nextTick(() => {
              this.waitingUrlOk = true;
            });
          });
      } else {
        this.$Message.error("不能为空");
        this.waitingUrlOk = false;
        this.$nextTick(() => {
          this.waitingUrlOk = true;
        });
      }
    },
    /** 切换图片列表展开/收起状态 */
    loadingPicture() {
      this.isShowPicList = !this.isShowPicList;
      this.picNum = this.isShowPicList ? this.currentImages.length + 5 : 5;
    },
    /** 拖拽开始 */
    dragStart(val, index) {
      this.oldVal = val;
      this.oldValIndex = index;
      this.isActive = val;
      this.isClick = true;
    },
    /** 拖拽结束（完成排序） */
    dragend(val, index) {
      if (this.oldValIndex != this.newOldIndex) {
        let newImages = [...this.currentImages];
        newImages.splice(this.oldValIndex, 1);
        newImages.splice(this.newOldIndex, 0, this.oldVal);
        this.updateCurrentImages(newImages);
        this.isActive = -1;
        setTimeout(() => {
          this.isClick = false;
        }, 1000);
      }
    },
    /** 拖拽进入目标位置 */
    dragEnter(val, index) {
      this.newOld = val;
      this.newOldIndex = index;
    },
    /** 打开 AI 生图弹窗（SPU维度） */
    openAiGenerateModal() {
      this.aiGenerateModalVisible = true;
    },
    /**
     * AI 生图完成回调
     * @param {Object} payload aiGenerateModal 组装的提交参数
     */
    handleAiGenerate(payload, result) {
      // eslint-disable-next-line no-console
      // console.log('[productImageInfo] AI生图 payload:', payload, 'result:', result);
    },
    /** 放大预览图片 */
    showViewer(index) {
      viewerApi({
        options: {
          toolbar: true,
          url: "dataSource",
          initialViewIndex: index,
        },
        images: this.viewerImages,
      });
    },
  },
};
</script>

<style scoped lang="less">
.head-tabs {
  // height: 100%;

  .ivu-radio-group {
    height: 100%;

    .ivu-radio-wrapper {
      height: 32px;
      line-height: 32px;
      border: none;

      &.ivu-radio-wrapper-checked {
        color: #fff;
        background: #2d8cf0;
        border-radius: 0;
      }

      &:before {
        content: "";
        display: none;
      }
    }
  }
}
.product-upload-list {
  width: 180px;
  height: 180px;
}

.product-upload-list-cover i {
  margin: 0 6px;
}

.pictureBtn {
  width: 20px;
  height: 100px;
  white-space: inherit;
  text-align: center;
  padding-right: 24px;
}
</style>

<style lang="less">
.product-img-box .ivu-checkbox {
  position: absolute;
  z-index: 999;
  left: 0;
  top: 0;
}

.productsCont {
  background-color: #fff;
  border: 1px solid #d7dde4;
}

.flip-list-move {
  transition: transform 0.3s ease-in;
}
</style>
